import { Component, OnInit } from "@angular/core";
import {
  NavController,
  ModalController,
  LoadingController,
  NavParams,
  AlertController,
  IonicModule,
} from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { EnqueteProvider } from "src/app/services/enquete/enquete";
import { EnqueteResultadoPage } from "../enquete-resultado/enquete-resultado.page";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { UserProvider } from "src/app/services/user/user";
import { ImagePipe } from "src/app/pipes/image/image";
import { NomenclaturaPipe } from "src/app/pipes/nomenclatura/nomenclatura";
import { LoadingSpinnerComponent } from "src/app/components/loading/loading-spinner/loading-spinner.component";

@Component({
  selector: "app-enquete-perguntas",
  templateUrl: "./enquete-perguntas.page.html",
  styleUrls: ["./enquete-perguntas.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    TranslateModule,
    ImagePipe,
    NomenclaturaPipe,
    LoadingSpinnerComponent,
  ],
})
export class EnquetePerguntasPage implements OnInit {
  idEnquete: any;
  primeira = true;
  aux: any = {};
  pergunta: any = {};
  alternativaRadio: any;
  alternativasCheck: any = [];
  alternativaTexto: any;
  disableBotoes = false;
  descricao: string;
  perguntasLength: any;
  nomenclaturaBotaoProximo: string;
  loaded = false;
  ordemStatus: string;

  semDependencia: any;
  totalPerguntas: any;
  dependentesAtivas = new Set<number>();
  respostasCache: { [idPergunta: number]: any } = {};

  get perguntasAtivas() {
    return [
      ...this.semDependencia,
      ...this.perguntasLength.filter((p: any) => p.idPerguntaDependente && this.dependentesAtivas.has(p.id)),
    ].sort((a, b) => a.ordem - b.ordem);
  }

  get perguntaNumeroExibida() {
    const idx = this.perguntasAtivas.findIndex((p) => p.id === this.pergunta.id);
    return idx >= 0 ? idx + 1 : 0;
  }

  get totalExibido() {
    return this.perguntasAtivas.length;
  }

  constructor(
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    public loadingController: LoadingController,
    public navParams: NavParams,
    public enqueteProvider: EnqueteProvider,
    public alertCtrl: AlertController,
    public translate: TranslateService,
    public userProvider: UserProvider
  ) {
    this.idEnquete = this.navParams.get("idEnquete");
    this.descricao = this.navParams.get("descricao");
    this.perguntasLength = this.navParams.get("perguntasLength");

    this.semDependencia = this.perguntasLength.filter((p: any) => !p.idPerguntaDependente);
    this.totalPerguntas = this.semDependencia.length;

    this.nomenclaturaBotaoProximo = this.navParams.get("nomenclaturaBotaoProximo");
    if (!this.nomenclaturaBotaoProximo) {
      this.nomenclaturaBotaoProximo = this.translate.instant("Próxima");
    }
    this.buscar();
    setTimeout(() => {
      this.loaded = true;
    }, 1000);
  }

  ngOnInit() {}

  private ativarPerguntaDependente(id: number) {
    if (!this.dependentesAtivas.has(id)) {
      this.dependentesAtivas.add(id);
      this.totalPerguntas++;
    }
  }

  private desativarPerguntaDependente(id: number) {
    if (this.dependentesAtivas.has(id)) {
      this.dependentesAtivas.delete(id);
      this.totalPerguntas--;
    }
  }

  responderPergunta() {
    let resposta;
    if (this.pergunta.tipo == 1) {
      resposta = this.alternativaRadio;
    } else if (this.pergunta.tipo == 2) {
      resposta = [...this.alternativasCheck];
    } else if (this.pergunta.tipo == 3) {
      const textoLimpo = (this.alternativaTexto || "").trim();
      if (!textoLimpo) return;
      resposta = textoLimpo;
    }

    this.respostasCache[this.pergunta.id] = resposta;

    this.aux.idEnquete = this.idEnquete;
    this.aux.tipo = this.pergunta.tipo;
    this.aux.pergunta = this.pergunta.id;
    this.aux.resposta = Array.isArray(resposta) ? resposta : [resposta];

    this.disableBotoes = true;
    this.enqueteProvider.responderPergunta(this.aux).subscribe(() => {
      this.buscar();
    });
  }

  async pular() {
    let alert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: this.translate.instant("Atenção!"),
      message: this.translate.instant("Deseja realmente pular essa pergunta?"),
      buttons: [
        {
          text: this.translate.instant("Cancelar"),
          role: "cancel",
        },
        {
          text: this.translate.instant("Sim"),
          handler: () => {
            this.disableBotoes = true;
            this.aux.idEnquete = this.idEnquete;
            this.aux.tipo = this.pergunta.tipo;
            this.aux.pergunta = this.pergunta.id;

            this.enqueteProvider.pularPergunta(this.aux).subscribe((data) => {
              this.buscar();
            });
          },
        },
      ],
    });
    alert.present();
  }

  async voltar() {
    let alert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: this.translate.instant("Atenção!"),
      message: this.translate.instant("Deseja realmente voltar para a pergunta anterior?"),
      buttons: [
        {
          text: this.translate.instant("Cancelar"),
          role: "cancel",
        },
        {
          text: this.translate.instant("Sim"),
          handler: () => {
            this.disableBotoes = true;

            if (this.pergunta.idPerguntaDependente) {
              this.desativarPerguntaDependente(this.pergunta.id);
            }

            this.enqueteProvider.voltarPergunta(this.idEnquete).subscribe((data) => {
              this.buscar();
            });
          },
        },
      ],
    });
    alert.present();
  }

  async buscar() {
    this.enqueteProvider.getProximaPergunta(this.idEnquete).subscribe(async (data) => {
      if (data.acabou) {
        await this.modalCtrl.dismiss({ acabou: true, idEnquete: this.idEnquete });
        return;
      }

      this.disableBotoes = false;
      this.pergunta = data.pergunta;
      this.primeira = data.primeira;
      this.ordemStatus = data.ordem

      const respostaSalva = this.respostasCache[this.pergunta.id];
      if (this.pergunta.tipo == 1) {
        this.alternativaRadio = respostaSalva || null;
      } else if (this.pergunta.tipo == 2) {
        this.alternativasCheck = respostaSalva || [];
        this.pergunta.alternativas.forEach((alt: any) => {
          alt.checked = this.alternativasCheck.includes(alt.id);
        });
      } else if (this.pergunta.tipo == 3) {
        this.alternativaTexto = respostaSalva || "";
      }

      if (data.pergunta.idPerguntaDependente) {
        this.ativarPerguntaDependente(data.pergunta.id);
      }

    });
  }

  changeCheck(alternativa: { checked: boolean }) {
    alternativa.checked = !alternativa.checked;
    let checkeds = this.pergunta.alternativas.filter((pergunta: { checked: any }) => pergunta.checked);
    this.alternativasCheck = [];
    checkeds.forEach((check: { id: string }) => {
      this.alternativasCheck.push(check.id);
    });
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
